import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Paragraph, TextButton, IconChevronUpOutline, IconChevronDownOutline } from "@zillow/constellation";
import { getDTIMessageParts } from "./DTICalculator.utils.esm.js";
const MAX_GOOD_DTI_RATIO = 36;
const DTIMessage = ({
  value,
  defaultExpanded
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const {
    result,
    description
  } = useMemo(() => getDTIMessageParts(value, expanded), [value, expanded]);
  const onClick = (e) => {
    e == null ? void 0 : e.preventDefault();
    setExpanded(!expanded);
  };
  return /* @__PURE__ */ jsxs(Box, { sx: {
    margin: "auto",
    "max-width": "400px"
  }, children: [
    /* @__PURE__ */ jsxs(Paragraph, { children: [
      /* @__PURE__ */ jsxs("strong", { children: [
        " ",
        result,
        " "
      ] }),
      description
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      display: value > MAX_GOOD_DTI_RATIO ? "block" : "none",
      padding: "$spacing.xs 0 $spacing.sm",
      margin: "auto",
      "text-align": "center",
      "@media $md_gte": {
        display: "none"
      }
    }, children: /* @__PURE__ */ jsx(TextButton, { onClick, "aria-expanded": expanded, children: expanded ? /* @__PURE__ */ jsxs(Fragment, { children: [
      "Read less ",
      /* @__PURE__ */ jsx(IconChevronUpOutline, { marginLeft: "xs" })
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      "Read more ",
      /* @__PURE__ */ jsx(IconChevronDownOutline, { marginLeft: "xs" })
    ] }) }) })
  ] });
};
DTIMessage.propTypes = {
  value: PropTypes.number,
  defaultExpanded: PropTypes.bool
};
export {
  DTIMessage,
  DTIMessage as default
};
